<template>
  <div class="orderRefunds">
    <template v-for="item in detail.ORDER_GOODS_DETAILS">
      <div class="orderRefunds-box f-webkit-box" :key="item.ID">
        <van-image :src="getImagePrefix + item.COVER_URL" radius="6" class="order-img" />
        <div class="f-box-flex1">
          <div class="order-title">{{item.PRODUCT_NAME}}</div>
          <div class="order-norms">规格：{{item.SKU_NAME}}</div>
        </div>
      </div>
    </template>

    <div class="orderRefunds-box orderRefunds-text lh-24">
      <span style="margin-right:16px">退款金额</span>
      <span class="f-size-14 f-color-FF7613">¥</span>
      <span class="f-size-16 f-color-FF7613">{{detail.ORDER_MONEY}}</span>
    </div>

    <div class="orderRefunds-box f-webkit-box">
      <div class="orderRefunds-text f-w-90">货物状态</div>
      <van-radio-group v-model="status" direction="horizontal" class="f-box-flex1">
        <van-radio name="未收到货" checked-color="#FF8530">未收到货</van-radio>
        <van-radio name="已收到货" checked-color="#FF8530">已收到货</van-radio>
      </van-radio-group>
    </div>
    <div class="orderRefunds-box f-webkit-box" v-touch:tap.prevent="test">
      <div class="f-box-flex1 orderRefunds-text">退款原因</div>
      <div class="f-info-r orderRefunds-text">{{radio}}</div>
      <div class="f-w-15 f-info-r">
        <i class="iconfont f-color-CECECE">&#xe6ab;</i>
      </div>
    </div>
    <div class="orderRefunds-box">
      <div class="orderRefunds-text">上传凭证</div>
      <van-uploader
        v-model="remarkPic"
        multiple
        preview-size="56"
        :max-count="6"
        upload-text="添加图片"
        class="orderRefunds-uploader"
      />
    </div>
    <div class="f-m-t-40">
      <van-button type="default" @click="submit">确 定</van-button>
    </div>
    <van-popup v-model="show" round class="sku-box" position="bottom">
      <div class="reason">
        <div class="reason-text">退款原因</div>
        <van-radio-group v-model="radio">
          <van-cell-group>
            <template v-for="item in list">
              <van-cell :title="item" clickable @click="radio = item" :key="item">
                <van-radio slot="right-icon" checked-color="#FF8530" :name="item" />
              </van-cell>
            </template>
          </van-cell-group>
        </van-radio-group>
        <van-button type="default" v-touch:tap="skuCommit" class="f-m-t-sm">确 定</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  Button,
  RadioGroup,
  Radio,
  Uploader,
  popup,
  Checkbox,
  CheckboxGroup,
  Cell,
  CellGroup
} from "vant";
import http from "@js/http-hbt.js";

import { getOrderDetail, refundOrder, uploadFile } from "@js/shoppingUrl.js";
export default {
  data() {
    return {
      //   image: require("../../lib/image/personalCenter/45.png"),
      //   icon: require("../../lib/image/personalCenter/zxj.png"),
      radio: "不喜欢", //退款原因
      remarkPic: [], //
      show: false, //上拉菜单
      list: ["不喜欢", "未按约定发货", "少发/漏发", "质量问题"], //复选框
      result: [],
      detail: {},
      status: "未收到货"
    };
  },
  computed: {
    getImagePrefix() {
      return this.$store.state.shoppingBlock.bgImgPrefix || "";
    }
  },
  methods: {
    //下拉菜单
    test() {
      this.show = true;
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    //确定按钮关闭
    skuCommit() {
      this.show = false;
    },

    getOrderDetail(orderId) {
      http.post(getOrderDetail, { orderId }).then(res => {
        this.detail = res.data;
      });
    },
    uploadFile(arr) {
   
      let files = arr.map(item => {
        return {
          FileUrl: item.content,
          IsRemoved: false,
          IsNew: true
        };
      });
      //,
      return http.post(
        uploadFile,
        { files: JSON.stringify(files) },
        {
          headers: { "content-type": "application/x-www-form-urlencoded" }
        }
      );
    },
    async submit() {
      let result = await this.uploadFile(this.remarkPic);

      let params = {
        orderId: this.orderId,
        refundType: 1,
        isAcc: 1,
        remarkPic: result.data.map(item => item.FileUrl),
        remark: `${this.status} ${this.radio}`
      };
      http.post(refundOrder, params).then(res => {
        let timer = setTimeout(() => {
          clearTimeout(timer)
          this.$toast({
            type: "success",
            message: "已提交退款申请",
            forbidClick: true,
            onClose: () => {
              this.$router.go(-1);
            }
          });
        }, 100);
      });
    }
  },
  created() {
    var {
      query: { orderId }
    } = this.$route;
    this.orderId = orderId;
    this.getOrderDetail(orderId);
  },
  components: {
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Uploader.name]: Uploader,
    [popup.name]: popup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  }
};
</script>

<style lang="less" scoped>
.orderRefunds {
  background-color: #eff0fa !important;
  padding: 15px 7px;
  .orderRefunds-text {
    color: #35373c;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
  .orderRefunds-box {
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 18px 15px;
    margin-bottom: 10px;
    .order-img {
      width: 86px;
      height: 84px;
      margin-right: 10px;
    }
    .order-title {
      color: #1a1b1d;
      font-size: 12px;
      line-height: 18px;
    }
    .order-norms {
      color: #1a1b1d;
      font-size: 12px;
      line-height: 18px;
      padding-top: 15px;
    }
    .lh-24 {
      line-height: 24px;
    }
    .f-w-90 {
      width: 90px;
    }
    .orderRefunds-uploader {
      margin-top: 15px;
    }
  }
  .reason {
    padding: 14px;
    .reason-text {
      text-align: center;
      color: #000;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .f-w-15 {
    width: 15px;
  }
  .f-size-14 {
    font-size: 14px;
  }
  .f-size-16 {
    font-size: 16px;
  }
  .f-color-FF7613 {
    color: #ff7613;
  }
  .f-info-r {
    text-align: right;
  }
  .f-color-CECECE {
    color: #cecece;
  }
  .f-m-t-40 {
    margin-top: 40px;
  }
  .f-m-t-sm {
    margin-top: 10px;
  }
  .f-box-flex1 {
    overflow: hidden;
    box-flex: 1;
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    flex: 1;
    -webkit-flex: 1;
  }
  .f-webkit-box {
    display: -webkit-flex;
    display: -webkit-box;
    display: -moz-flex;
    display: -moz-box;
    display: -ms-flex;
    display: -ms-box;
    // display: box;
    display: flex;
  }
}
</style>